import React, { useState } from "react";
import { CheckboxFilter } from "../components/tailwind";
import type { CheckboxFilterOption } from "../components/tailwind";

type LanguageOption = {
  value: string;
  short_name: string;
  flag: string;
};

type Props = {
  allLanguages: LanguageOption[];
  selectedLanguages: string[];
  baseUrl: string;
};

const SELECT_ALL_VALUE = "__all__";

export const TranslationHomeLanguageSelector: React.FC<Props> = ({
  allLanguages,
  selectedLanguages,
  baseUrl,
}) => {
  const [pendingSelection, setPendingSelection] = useState<string[]>(
    selectedLanguages
  );

  const allOption: CheckboxFilterOption = {
    value: SELECT_ALL_VALUE,
    label: "Select All",
  };
  const languageOptions: CheckboxFilterOption[] = allLanguages.map((lang) => ({
    value: lang.value,
    label: `${lang.flag} ${lang.short_name} (${lang.value})`,
  }));
  const options = [allOption, ...languageOptions];

  const pendingAllSelected =
    allLanguages.length > 0 && pendingSelection.length === allLanguages.length;
  const displaySelected = pendingAllSelected
    ? [...pendingSelection, SELECT_ALL_VALUE]
    : pendingSelection;

  const handleChange = (selected: string[]): void => {
    let values: string[];
    if (selected.includes(SELECT_ALL_VALUE) && !pendingAllSelected) {
      values = allLanguages.map((l) => l.value);
    } else if (pendingAllSelected && !selected.includes(SELECT_ALL_VALUE)) {
      values = [];
    } else {
      values = selected.filter((v) => v !== SELECT_ALL_VALUE);
    }
    setPendingSelection(values);
  };

  const handleApply = (): void => {
    const url =
      pendingSelection.length > 0
        ? `${baseUrl}?languages=${pendingSelection.join(",")}`
        : baseUrl;
    window.location.href = url;
  };

  const handleClear = (): void => {
    setPendingSelection([]);
  };

  return (
    <div className="tw-w-128">
      <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
        Languages
      </label>
      <CheckboxFilter
        options={options}
        selected={displaySelected}
        onChange={handleChange}
        onApply={handleApply}
        onClear={handleClear}
        placeholder="Select languages..."
        testIdBase="translation-language-filter"
      />
    </div>
  );
};
